"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var verticalLine = function verticalLine(theme, left) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("height:12.6px;width:auto;border-left:solid 1.9px ", theme.color.dark.zinc, ";", left &&
    /*#__PURE__*/
    (0, _emotion.css)("margin-left:7px;margin-right:-2.2px;"), ";", !left &&
    /*#__PURE__*/
    (0, _emotion.css)("margin-right:7px;margin-left:-3.2px;"), ";")
  );
};

var buttonContainer =
/*#__PURE__*/
(0, _emotion.css)("display:flex;align-items:center;justify-content:center;");
var _default = {
  verticalLine: verticalLine,
  buttonContainer: buttonContainer
};
exports.default = _default;